import { docReady } from '../helpers/docReady';
import '../../styles/templates/password.scss';
// import { functionName } from '../sections/fileName';
docReady(() => {
    // functionName();
});
